import React, { useState } from "react";
import { Accordion, useAccordionButton } from "react-bootstrap";
import { ChevronDown, ChevronUp } from "lucide-react";

export const CustomAccordion: React.FC<{
  icon: JSX.Element;
  title: string;
  open: boolean;
  children: React.ReactNode;
}> = ({ icon, title, children, open }) => {
  const [whoOpen, setHowOpen] = useState<string>(open ? "0" : "");

  return (
    <div className="">
      <Accordion className="" defaultActiveKey={whoOpen}>
        <CustomToggle whoOpen={whoOpen} setHowOpen={setHowOpen} eventKey={"0"}>
          <div
            className={`d-flex flex-row  align-items-center justify-content-between g-cursor-pointer py-2 px-3 ${
              whoOpen == "0" ? "bg-custom-light" : ""
            }`}
          >
            <div className={"d-flex flex-row gap-2"}>
              <div className={`${whoOpen == "0" ? "prm2-text" : "text3"}`}>
                {icon}
              </div>
              <span className={`${whoOpen == "0" ? "text2" : "text3"} mt-1`}>
                {title}
              </span>
            </div>
            {whoOpen == "0" ? (
              <ChevronUp className={"text2"} />
            ) : (
              <ChevronDown className={"text3"} />
            )}
          </div>
        </CustomToggle>
        <Accordion.Collapse eventKey="0">
          <div
            className="py-2"
            style={{ paddingLeft: "3rem", paddingRight: "3rem" }}
          >
            {children}
          </div>
        </Accordion.Collapse>
      </Accordion>
    </div>
  );
};

export const CustomToggle: React.FC<{
  children: React.ReactNode;
  eventKey: string;
  setHowOpen: Function;
  whoOpen: string;
}> = ({ children, eventKey, setHowOpen, whoOpen }) => {
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    handleOnClick();
  });

  const handleOnClick = () => {
    if (whoOpen == eventKey) {
      setHowOpen("");
    } else {
      setHowOpen(eventKey);
    }
  };

  return (
    <div
      className={`${eventKey != "0" && "border-top"} `}
      onClick={decoratedOnClick}
    >
      {children}
    </div>
  );
};
